// import one from "../assets/svg/projects/one.svg";
// import two from "../assets/svg/projects/two.svg";
// import three from "../assets/svg/projects/three.svg";
// import four from "../assets/svg/projects/four.svg";
// import five from "../assets/svg/projects/five.svg";
// import six from "../assets/svg/projects/six.svg";
// import seven from "../assets/svg/projects/seven.svg";
// import eight from "../assets/svg/projects/eight.svg";
// import udemy from "../assets/png/udemy2.jpeg";

export const projectsData = [
  {
    id: 1,
    projectName: "Bewakoof Clone",
    projectDesc: [
      `Bewakoof is an Online Shopping site for Men and Women Clothing.`,
      [
        "Created Navbar,Cart page",
        "Women's shopping page",
        "Sort and filter functionalities",
      ],
    ],
    tags: ["JavaScript", "CSS", "HTML"],
    code: "https://github.com/venkycoder422/bewakoof.github.io",
    demo: "https://venkycoder422.github.io/bewakoof.github.io/",
    image:
      "https://user-images.githubusercontent.com/76251822/200834257-405afcc9-1539-4717-9c0e-83f87fca9396.gif",
  },

  {
    id: 4,
    projectName: "Anthropologie Clone",
    projectDesc: [
      "Anthropologie is a website which sells women clothings and home furnitures.",
      [
        "Build landing page and cloths page",
        "Sort and pagination functinality",
        "Bug fixers",
      ],
    ],
    tags: ["React","Redux","json"],
    code: "https://github.com/venkycoder422/Anthropologie/tree/venky/project",
    demo: "https://anthropologie1.netlify.app/",
    image:
      "https://user-images.githubusercontent.com/76251822/201025501-9c12886d-9f15-4ab1-a3cc-6ce11a129ac5.gif",
  }
  ,
  {
    id: 3,
    projectName: "Pinterest Clone",
    projectDesc: [
      "The Pinterest is a photo and video sharing website.",
      [
        "Built navbar and pins page",
        "Search functinality",
        "Video feature for all ages",
      ],
    ],
    tags: ["MongoDB", "Express", "React","Node JS"],
    code: "https://github.com/venkycoder422/pinterest-clone",
    demo: "https://pinterestclone1.netlify.app/",
    image:
      "https://user-images.githubusercontent.com/76251822/201025528-3b1f3dcf-dc0e-419c-ad11-ba84b5edbbdb.gif",
  },
  {
    id: 2,
    projectName: "Indian Recipes",
    projectDesc: [
      "This was an individual project where I created a website about recipes, cooking techniques and ingredients.",
      ["Login, Sign Up pages", "Authorization", "Recipes page."],
    ],
    tags: ["React", "Redux", "json"],
    code: "https://github.com/venkycoder422/Indian-food",
    demo: "https://indianfood.vercel.app/",
    image:
      "https://user-images.githubusercontent.com/76251822/201025515-050e6371-2ae9-41ee-92c2-6f824038b420.gif",
  },
  {
    id: 5,
    projectName: "Waist Measurement",
    projectDesc: [
      "This website gives the waist size of a person.",
      ["Home page,Check size."],
    ],
    tags: ["React", "Java","Spring Boot","MySQL","Azure"],
    code: "https://github.com/venkycoder422/WaistMeasurementFrontend",
    demo: "https://waist-measurement-frontend.vercel.app/",
    image:
      "https://github.com/venkycoder422/WaistMeasurementFrontend/assets/76251822/c6ab5993-b5af-433f-bd0f-94e7cc4ec72c",
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
